<template>
<div>
    <b-container>
        <b-row>
            <b-col>
                <b-form-select  v-model = arg.selectPort
                                :options = portOption
                                @input = setDate>
                </b-form-select >
            </b-col>
            <b-col>
                <b-form-select  v-model = arg.inoutPort
                                :options = inoutPortOption
                                @input = setDate>
                </b-form-select >
            </b-col>
        </b-row>
        <b-row>
            
            <b-col>
                <b-btn v-b-toggle="'detail_search'" class="m-1" :disabled = enableSearch>更多功能</b-btn>
            </b-col>
            <b-col>
                <date-picker v-model="arg.spArrvDtFrom" :config="config" @dp-change="setDate"></date-picker>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
               
            </b-col>
            <b-col>
                <b-btn class="m-1" @click="search(arg)" :disabled = enableSearch>查詢</b-btn>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-collapse id="detail_search">
                    <b-card>
                    <b-row>
                        <b-col>
                            <b-input-group>
                                <b-form-input 
                                                    type="text"
                                                    placeholder="船舶號數"
                                                    v-model="arg.spVesselNo"
                                ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col>
                            <b-input-group>
                                <b-form-input 
                                                    type="text"
                                                    placeholder="簽證編號"
                                                    v-model="arg.visaNo"
                                ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-input-group>
                                <b-form-input 
                                                    type="text"
                                                    placeholder="英文船名"
                                                    v-model="arg.vesselEname"
                                ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col>
                            <b-input-group>
                                <b-form-input 
                                                    type="text"
                                                    placeholder="中文船名"
                                                    v-model="arg.vesselCname"
                                ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-input-group>
                                <b-form-input 
                                                    type="text"
                                                    placeholder="呼號"
                                                    v-model="arg.callSign"
                                ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col>
                            <b-input-group>
                                <b-form-input 
                                                    type="text"
                                                    placeholder="船隻掛號"
                                                    v-model="arg.registerNo"
                                ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    
                </b-card>
                </b-collapse>
            </b-col>
        </b-row>
    </b-container>
    <b-table 
            striped
            hover 
            fixed
            :sort-desc.sync="sortDesc"
            :fields = tableFields
            :items = items
            @row-clicked = rowClick
            >
           
    </b-table>
</div>
</template>

<script>
//https://www.npmjs.com/package/vue-bootstrap-datetimepicker
// datetimepicker

var moment = require('moment');

export default {
    name: "basicSearchUI",
    props:{
        tableFields: Array,
        items: Array,
        search: Function,
        dateString: String,
        enableSearch: Boolean,
        rowClick:Function
    },
    data () {
        return {
            fields:null,
            
            config: {
                format: 'YYYY/MM/DD 00:00',
                useCurrent: false,
            },
            sortDesc: false,
            inoutPortOption:[
            {text:"進港",value:"進港"},
            {text:"出港",value:"出港"}
            ],
            portOption:[
                {text:"基隆港",value:"KEL"},
                {text:"台北港",value:"TPE"},
                {text:"蘇澳港",value:"SUO"},
                {text:"台中港",value:"TXG"},
                {text:"花蓮港",value:"HUN"},
                {text:"高雄港",value:"KHH"},
                {text:"安平港",value:"APG"},
                {text:"澎湖港",value:"MZG"},
                {text:"布袋港",value:"PUT"}

            ],
            arg:{
                selectPort: "KEL",
                special01: "False",
                special02: "False",
                spArrvDtFrom: moment().format('YYYY/MM/DD 00:00').toString(),
                spArrvDtTo: moment().add(1,'days').format('YYYY/MM/DD 00:00').toString(),
                inoutPort: "進港",

                visaNo: undefined, //簽證編號
                vesselCname: undefined, //中文名稱
                callSign: undefined, //船舶呼號
                vesselEname: undefined, //英文名稱
                spVesselNo: undefined, //船舶號數
                registerNo: undefined//船舶掛號
            }
        }
    },
    
    computed: {
        

    },
    methods: {
        setDate: function(){
            
            this.arg.spArrvDtTo = moment(this.arg.spArrvDtFrom,'YYYY/MM/DD 00:00').add(1,'days').format('YYYY/MM/DD 00:00').toString()
            this.$emit('getData',this.arg);
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/basicSearchUI.vue